module.exports = __webpack_public_path__ + "a8d3e5084d8c1b55cfb87410a5ba06de.png";